// removed by extract-text-webpack-plugin
module.exports = {"container":"_2qnM","whiteVariant":"_2UlD","link":"_3lkV","wrapper":"_2p_w","links":"_33FC","logo":"_1Os3","imageContainer":"QhUy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuBar/styles.scss
// module id = 317
// module chunks = 0